import { useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import * as Yup from "yup";
import { X_API_KEY } from "../../../../constants";
import { API_URL } from "../../../../config/apiConfig";

export const POLICY_STATUS_CONSTATNS = {
  TITLE: "Check your Policy status using your IMEI number.",
  IMEI_LABEL: "Enter IMEI",
  SEARCH_POLICY_BUTTON: "Search Policy",
  POLICY_DETAILS: "Policy Details: ",
  MOBILE_NUMBER: "Mobile Number: ",
  USER_NAME: "User Name: ",
  PLAN_NAME: "Plan Name: ",
  POLICY_STATUS: "Policy Status: ",
  REASON: "Reason: ",
  POLICY_PUNCHING_DATE: "Policy Punching Date: ",
  POLICY_NOT_FOUND: "Policy Not Found",
  POLICY_NOT_FOUND_DESC:
    "Sorry, we couldn't find any information for the provided IMEI.",
  ENTER_VALID_IMEI_DESC:
    "Please enter a valid IMEI number to search for details.",
};

export const usePolicyStatusData = ({ setIsLoading }) => {
  const [searchPolicyStatus, setSearchPolicyStatus] = useState(null);
  const [hasSearchedPolicyStatus, setHasSearchedPolicyStatus] = useState(false);

  const policyStatusFormik = useFormik({
    initialValues: { policyImei: "" },
    validationSchema: Yup.object({
      policyImei: Yup.string()
        .required("*IMEI is required")
        .matches(/^[0-9]+$/, "Only numbers allowed")
        .length(15, "IMEI must be exactly 15 digits"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      setHasSearchedPolicyStatus(true);
      setSearchPolicyStatus(null);

      try {
        axios(`${API_URL.GET_CERTIFICATE_STATUS}${values?.policyImei}`, {
          method: "GET",
          headers: {
            "x-api-key": X_API_KEY,
            "Content-Type": "application/json",
          },
        })
          .then((res) => {
            if (res?.data?.statusCode === 200) {
              setSearchPolicyStatus(res?.data?.data);
              setIsLoading(false);
            }
            setIsLoading(false);
          })
          .catch((e) => {
            setIsLoading(false);
          });
      } catch (err) {
        if (err?.code === "ERR_NETWORK") {
          toast.error("Network error. Please try again.");
          setIsLoading(false);
        } else {
          toast.error(
            err?.response?.data?.message ||
              err?.res?.data?.message ||
              "Something went wrong"
          );
          setIsLoading(false);
        }
      } finally {
        setIsLoading(false);
      }
    },
  });

  const formattedDate = new Date(
    searchPolicyStatus?.issuesDate
  ).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return {
    formattedDate,
    searchPolicyStatus,
    setSearchPolicyStatus,
    policyStatusFormik,
    hasSearchedPolicyStatus,
    setHasSearchedPolicyStatus,
  };
};
